// @ts-nocheck
import { createContext, useContext, useState } from 'react';
import { Signature } from '../models/Signature';
import SignatureService from '../services/SignatureService';
import logger from '../utils/logger.utils';

export const RetentionSignatureContext = createContext({});
export const useRetentionSignature = (): any => useContext(RetentionSignatureContext);

const RetentionSignatureProvider = ({ children }: any) => {
  const [stepLoading, setStepLoading] = useState(false);
  const [nextStepDisabled, setNextStepDisabled] = useState(false);
  const [prevStepDisabled, setPrevStepDisabled] = useState(false);
  const [errorSignature, setErrorSignature] = useState(false);
  const [errorGelocation, setErrorGelocation] = useState(false);
  const [errorCam, setErrorCam] = useState(false);
  const [retentionReason, setRetentionReason] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [formOpened, setFormOpened] = useState(new Signature());
  const [step, setStep] = useState(1);

  const prevStep = () => {
    setStep((previousStep: any) => previousStep - 1);
  };

  const nextStep = async (e: any) => {
    e.preventDefault();

    if (step === 1) {
      setStep((previousStep: any) => previousStep + 1);
    }
    if (step === 2) {
      setStepLoading(true);

      const payload = {
        ip: formOpened.customerIP,
        longitude: formOpened.customerLatitude,
        latitude: formOpened.customerLongitude,
        token: formOpened.token,
        terms: ['PAYROLL_LOAN'],
      };
      const fetchDataTerms = await SignatureService.acceptRetentionTerms(payload);
      const { response } = fetchDataTerms;

      if (response != null) {
        if (response.status === 400 && response.data.validationErrors === undefined) {
          logger.error('Error on the response');
          setStepLoding(false);
          return 0;
        }

        return 0;
      }
      setFormOpened({
        ...formOpened,
      });
      setStepLoading(false);
      setStep((previousStep: any) => previousStep + 1);
    }
    if (step === 3) {
      // Step 3 logic is handled in ProposalListRetention component
      // Just advance to next step
      setStep((previousStep: any) => {
        const newStep = previousStep + 1;
        return newStep;
      });
    }
    if (step === 4) {
      setStep((previousStep: any) => previousStep + 1);
    }
    if (step === 5) {
      setStepLoading(true);
      try {
        const response = await SignatureService.getSignatureFlow(formOpened.token);

        if (!response || response instanceof Error || (response.status && response.status >= 400)) {
          logger.error('Erro ao buscar tipo de fluxo retention: resposta inválida ou erro', response);
          setStepLoading(false);
          setErrorSignature(true);
          return 0;
        }

        const flowType = response.data?.flowType;
        const isLiveness = flowType?.toLowerCase() === 'liveness';

        setFormOpened({
          ...formOpened,
          isLivenessSignature: isLiveness,
          flowType: flowType,
        });

        setStepLoading(false);
        setStep((previousStep: any) => previousStep + 1);
      } catch (err) {
        logger.error('Erro ao buscar tipo de fluxo (Liveness/Selfie)', err);
        logger.error('Erro ao buscar tipo de fluxo (Liveness/Selfie)', err);
        setStepLoading(false);
        setErrorSignature(true);
      }
    }
    if (step === 8) {
      setStepLoading(true);
      try {
        const fetchProposalSignature = await SignatureService.sendProposalRetention(formOpened);
        const { status } = fetchProposalSignature;

        if (status === 202) {
          setStep((previousStep: any) => previousStep + 1);
          setStepLoading(false);
        } else {
          throw new Error('Error Signature');
        }
      } catch (err) {
        logger.error('Error fetching the proposal signature');
        setStepLoading(false);
        setErrorSignature(true);
      }
    }
  };

  const values = {
    nextStepDisabled,
    setNextStepDisabled,
    prevStepDisabled,
    setPrevStepDisabled,
    step,
    setStep,
    prevStep,
    nextStep,
    formOpened,
    setFormOpened,
    showModal,
    setShowModal,
    stepLoading,
    errorSignature,
    setErrorSignature,
    errorGelocation,
    setErrorGelocation,
    errorCam,
    setErrorCam,
    retentionReason,
    setRetentionReason,
  };

  return <RetentionSignatureContext.Provider value={{ ...values }}>{children}</RetentionSignatureContext.Provider>;
};

export { RetentionSignatureProvider };

